/* French Cuff cart upsell - adds the matching French-cuff variant as its own line, qty 1. */
(function () {
  var SECTION_ID = 'cart-drawer';

  document.body.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-add-french-cuff');
    if (!btn) return;
    event.preventDefault();
    if (btn.dataset.loading === '1') return;

    var variantId = Number(btn.dataset.variantId);
    var quantity = parseInt(btn.dataset.quantity || '1', 10) || 1;
    if (!variantId) return;

    // GA4: French-cuff offer clicked
    if (window.gtag) {
      gtag('event', 'french_cuff_offer_click', {
        variant_id: variantId,
        location: document.querySelector('.main-cart') ? 'cart_page' : 'cart_drawer'
      });
    }

    btn.dataset.loading = '1';
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          console.warn('[FC upsell] add failed:', res.description || res.message);
          resetBtn(btn);
          return;
        }
        if (document.querySelector('.main-cart')) {
          window.location.reload();
          return;
        }
        refreshCartDrawerInner();
      })
      .catch(function (err) { console.error('[FC upsell] add error:', err); resetBtn(btn); });
  });

  function resetBtn(btn) {
    btn.dataset.loading = '';
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }

  function refreshCartDrawerInner() {
    fetch(window.Shopify.routes.root + '?section_id=' + SECTION_ID)
      .then(function (r) { return r.text(); })
      .then(function (markup) {
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var newInner = doc.querySelector('.cart-drawer-inner');
        var currentInner = document.querySelector('cart-drawer .cart-drawer-inner');
        if (newInner && currentInner) currentInner.replaceWith(newInner);

        var newCount = doc.querySelector('.cart-count');
        if (newCount) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.textContent = newCount.textContent;
          });
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer) { drawer.setAttribute('aria-hidden', 'false'); drawer.classList.add('active'); }
        attachOrphanObservers();
      })
      .catch(function (err) { console.error('[FC upsell] drawer refresh error:', err); });
  }

  function pruneOrphanOffers() {
    document.querySelectorAll('[data-fc-for-key]').forEach(function (offer) {
      var key = offer.getAttribute('data-fc-for-key');
      if (!document.querySelector('.cart-product[data-item-key="' + key + '"]')) offer.remove();
    });
  }

  var observers = [];
  function attachOrphanObservers() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    document.querySelectorAll('.cart-products').forEach(function (list) {
      var o = new MutationObserver(pruneOrphanOffers);
      o.observe(list, { childList: true });
      observers.push(o);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachOrphanObservers);
  } else {
    attachOrphanObservers();
  }
})();